import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'ui-filter-pill',
  standalone: true,
  templateUrl: './filter-pill.component.html',
  styleUrls: ['./filter-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterPillComponent {

}
